import CollectionProto from "../../data-structures/depricated/collection-proto";
import AssignedTask from "../../model2/task/task-assigned";

const debug = false
// const debug = 'AssignedTasksCollection'

export default class AssignedTasksCollection extends CollectionProto<AssignedTask> {

    public future       : boolean   = false
    public planning       : boolean   = false

    constructor() {
        super([], AssignedTask)

        this.future = false;        // na samom dele eto ALL assigned with dates
        this.planning = false;      // all assigned without dates
    }

    get tasks() {
        return this._models
    }

    toJSON() {
        return _.map(this._models, (task:AssignedTask)=>{
            return task.toJSON()
        })
    }

    /*get notPlannedTasks() {
        return _.filter(this._models, t=>!t.startDate);
    }*/

    reset(models:any[], options = {}) {

        this._models = [];
        this._byId   = {};

        _.map(models, (modelData) => {
            // we always have this.MODEL_CLASS and add always creates model...
            this.add(modelData, options);
        })

        // ORIGINAL CODE
        // _.map(models, (modelData) => {
        //     if (this.MODEL_CLASS)   {
        //         this.add(new this.MODEL_CLASS(modelData), options);
        //     } else {
        //         this.add(modelData, options);
        //     }
        // })

    }

    resetFull(tasks:any) {
        this.reset(tasks, {silent: true});

        this.future = true;
        this.planning = true;

        gd.bus.triggerEvent('session.assigned-tasks.reset');
    }

    resetDefault(tasks:any) {
        this.reset(tasks, {silent: true})
        this.future = false;
        this.planning = false;

        gd.bus.triggerEvent('session.assigned-tasks.reset');
    }

    resetPlanning(tasks:any) {

        debug && console.log(debug, "resetPlanning()")

        _.map(tasks, task=>{
            if (!this.get(task.id)) this.add(new this.MODEL_CLASS(task), {silent: true})
        })

        this.planning = true;

        gd.bus.triggerEvent('session.assigned-tasks.reset');
    }

    add(task:any, options:any = {}) {

        super.add(new AssignedTask(task))

        if (!options.silent) gd.bus.triggerEvent('gd.session.assignedTasks:add', this.get(task.id))
    }

    remove(id:ID) {
        const removed = super.remove(id)

        gd.bus.triggerEvent('gd.session.assignedTasks:remove', id)

        return removed
    }

    async applyDelta(taskId:ID, newData:any) {
        const task = _.find(this._models, task => task.id === taskId)

        debug && console.log(debug, 'applyDelta', taskId, newData, task)

        if (task) {
            if (newData.hasOwnProperty('assignedToUserId') && newData.assignedToUserId !== gd.user.id) { // if assignedToUserId is changed and is NOT self user then remove task from collection of assigned tasks
                this.remove(taskId)
                debug && console.log(debug, 'applyDelta task removed', taskId)
            } else { // otherwise apply changes to existing task
                task.applyDelta(newData)
                debug && console.log(debug, 'applyDelta applied', task)

                gd.bus.triggerEvent('gd.session.assignedTasks:change', task)
            }
        } else {
            debug && console.log(debug, 'applyDelta task skipped', taskId)
        }
    }

    getTask(taskId:ID) {
        return this.get(taskId)
    }
}
